module.exports = __webpack_public_path__ + "media/images/lb/476-3afaefe4845964317093257bb3d40ad5.svg";